(function ($) {

  var timer = null;

  function submitCart($input) {
    clearTimeout(timer);
    timer = setTimeout(function () {
      $input.closest('form').submit();
    }, 600);
  }

  // ✅ ESCRIBIR MANUAL (el que ya sabes que sirve)
  $('body').on('keyup', 'form[action="/cart"] input[name="updates[]"]', function () {
    submitCart($(this));
  });

  // ✅ CLICK EN + / – (SIMULACIÓN)
  $('body').on('click', '.js-qty__adjust', function () {

    var $input = $(this).siblings('input[name="updates[]"]');

    if ($input.length) {
      // darle chance al theme de actualizar el valor primero
      setTimeout(function () {
        submitCart($input);
      }, 50);
    }

  });

})(jQuery);
